import { render, staticRenderFns } from "./OutdetailModel.vue?vue&type=template&id=d81f7858&scoped=true"
import script from "./OutdetailModel.vue?vue&type=script&lang=js"
export * from "./OutdetailModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81f7858",
  null
  
)

export default component.exports